import {
  useQuery,
  useMutation,
  useQueryClient,
  type QueryKey,
} from '@tanstack/react-query';
import service from '@Service';
import type { AgentContact } from '@Types/agent';

export const agentContactKeys = {
  forSoul: (soulId: string) => ['agent-contacts', soulId] as const,
};

export function useAgentContacts({
  soulId,
  enabled = true,
}: {
  soulId?: string;
  enabled?: boolean;
}) {
  return useQuery<AgentContact[]>({
    queryKey: agentContactKeys.forSoul(soulId!) as unknown as QueryKey,
    queryFn: () => service.getAgentContacts(soulId!),
    enabled: enabled && !!soulId,
  });
}

export function useAddContact(soulId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (userId: string) => service.createAgentContact(soulId, userId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: agentContactKeys.forSoul(soulId),
      }),
  });
}

export function useRemoveContact(soulId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (contactId: string) =>
      service.deleteAgentContact(soulId, contactId),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: agentContactKeys.forSoul(soulId),
      }),
  });
}
